import { JSXElementConstructor, ReactElement } from 'react';

import { isString } from 'lodash';

import { nanoid } from 'nanoid';

import AcceptanceEnvironmentButton from './AcceptanceEnvironmentButton';
import DevelopmentEnvironmentButton from './DevelopmentEnvironmentButton';
import ProductionEnvironmentButton from './ProductionEnvironmentButton';
import TestingEnvironmentButton from './TestingEnvironmentButton';

import { DtapStep, Environment } from '../../../../../types';
import { AlternativeEnvironmentButtonProps } from './types';

const ALTERNATIVE_ENVIRONMENT_BUTTONS: Record<
  DtapStep,
  ({
    url,
    title,
    badgeContent,
  }: AlternativeEnvironmentButtonProps) => ReactElement<
    any,
    string | JSXElementConstructor<any>
  >
> = {
  development: DevelopmentEnvironmentButton,
  testing: TestingEnvironmentButton,
  acceptance: AcceptanceEnvironmentButton,
  production: ProductionEnvironmentButton,
};

export interface AlternativeEnvironmentButtonFactoryProps {
  environment: Environment;
  dtapStep: DtapStep;
  appName: string;
  appTitle?: string;
}

export default function AlternativeEnvironmentButtonFactory({
  environment,
  dtapStep,
  appName,
  appTitle,
}: AlternativeEnvironmentButtonFactoryProps): ReactElement {
  const ButtonComponent = ALTERNATIVE_ENVIRONMENT_BUTTONS[dtapStep];

  if (isString(environment))
    return (
      <ButtonComponent
        url={environment}
        appName={appName}
        appTitle={appTitle}
      />
    );

  return (
    <>
      {environment
        .map((env) => ({ ...env, id: nanoid() }))
        .map(({ id, ...environmentProps }) => (
          <ButtonComponent
            key={id}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...environmentProps}
            appName={appName}
            appTitle={appTitle}
          />
        ))}
    </>
  );
}
